const PROD_API = "https://api.4sightlabs.com/CP-Pro-API";
const STAGING_API = "https://api.4sightlabs.com/CP-Pro-API-Staging";

const STAGING_HOSTS = [
  "overwatch-webapp-staging-b8abbwdvdkb3e2a3.z01.azurefd.us",
];

const useStaging =
  import.meta.env.DEV || STAGING_HOSTS.includes(window.location.hostname);

export const baseUrl = useStaging ? STAGING_API : PROD_API;
